<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path v-for="(path, index) in paths" :key="index" :d="path" />
  </svg>
</template>

<script>
const icons = {
  clock: ['M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0', 'M12 7v5l3 2'],
  check: ['m5 12 4 4L19 6'],
  arrow: ['M5 12h14', 'm13 6 6 6-6 6'],
  download: ['M12 3v12', 'm7 10 5 5 5-5', 'M4 16v4h16v-4'],
  link: ['m10 14 4-4', 'M8.5 15.5 7 17a3.54 3.54 0 0 1-5-5l4-4a3.54 3.54 0 0 1 5 0', 'm15.5 8.5 1.5-1.5a3.54 3.54 0 0 1 5 5l-4 4a3.54 3.54 0 0 1-5 0'],
  calendar: ['M5 5h14v16H5z', 'M8 2v6M16 2v6M5 10h14', 'M8 14h2M14 14h2M8 17h2'],
  pin: ['M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 0 1 14 0Z', 'M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0'],
  mail: ['M3 5h18v14H3z', 'm3 5 9 8 9-8'],
  ticket: ['M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4Z', 'M15 5v3m0 3v2m0 3v3'],
  lock: ['M6 10h12v11H6z', 'M8 10V6a4 4 0 0 1 8 0v4', 'M12 14v3'],
  replay: ['M4 10a8 8 0 1 1 1 7', 'M4 4v6h6'],
  close: ['m6 6 12 12M6 18 18 6'],
  share: ['M12 15V2', 'm7 7 5-5 5 5', 'M5 11H3v10h18V11h-2'],
  instagram: ['M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Z', 'M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0', 'M17.5 6.5h.01'],
  whatsapp: ['M20 11.5a8 8 0 0 1-12 7l-5 1.5 1.5-5a8 8 0 1 1 15.5-3.5Z', 'M8 8c0 4 4 8 8 7l-2-3-2 1-2-2 1-2-3-1Z'],
}
export default {
  name: 'ReceiptIcon',
  props: { name: { type: String, required: true } },
  computed: { paths() { return icons[this.name] || icons.arrow } },
}
</script>
